import Vue from 'vue';
import WorkTableActionWrapper from '@/components/global_components/tables/WorkTableActionWrapper';
import WorkTableChips from '@/components/global_components/tables/WorkTableChips';
import WorkTableChipsTooltipWrapper from '@/components/global_components/tables/WorkTableChipsTooltipWrapper';
import WorkBaseLevelTableLookALike from '@/components/global_components/tables/WorkBaseLevelTableLookALike';
import WorkHeaderPicker from '@/components/global_components/tables/WorkHeaderPicker';
import WorkFilesTable from '@/components/global_components/tables/WorkFilesTable';
import FixedSumRow from '@/components/global_components/tables/fixed-sum-row/FixedSumRow';

Vue.component('WTableActionWrapper', WorkTableActionWrapper);
Vue.component('WTableChips', WorkTableChips);
Vue.component('WTableChipsTooltipWrapper', WorkTableChipsTooltipWrapper);
Vue.component('WBaseLevelTableLookALike', WorkBaseLevelTableLookALike);
Vue.component('WFilesTable', WorkFilesTable);
Vue.component('WHeaderPicker', WorkHeaderPicker);
Vue.component('WFixedSumRow', FixedSumRow);
